module.exports = __webpack_public_path__ + "static/media/kate-mara-win.58730700.jpg";